let invoicePdfWindow: Window | null = null;

export function openInvoicePdfWindow(companySlug?: string) {
  if (!companySlug) return;

  const url = `${window.location.origin}/${companySlug}/doppelansicht`;

  if (invoicePdfWindow && !invoicePdfWindow.closed) {
    invoicePdfWindow.focus();
    invoicePdfWindow.location.href = url;
    return;
  }

  try {
    const win = window.open(
      url,
      "invoicePdfViewer",
      `popup=yes,width=${screen.availWidth},height=${screen.availHeight},left=0,top=0,resizable=yes,noopener=yes`,
    );

    if (win) {
      invoicePdfWindow = win;
      win.addEventListener("beforeunload", () => {
        invoicePdfWindow = null;
      });
      win.focus();
    } else {
      console.warn("Popup blocked or not yet ready");
    }
  } catch (err) {
    console.error("Error opening popup:", err);
  }
}
